/** A favorite's price as a number, or null when the listing had none. */
export function favoritePrice(value) {
  if (value == null || value === '') return null
  const n = typeof value === 'number' ? value : Number(String(value).replace(/[^0-9.]/g, ''))
  return Number.isFinite(n) && n > 0 ? n : null
}

export function formatFavoritePrice(value) {
  const n = favoritePrice(value)
  return n == null ? null : `$${n.toFixed(2)}`
}

/** Sum of the favorites that have a price, plus how many had one. */
export function favoritesTotal(items = []) {
  let total = 0
  let priced = 0
  for (const item of items) {
    const n = favoritePrice(item?.price)
    if (n != null) {
      total += n
      priced += 1
    }
  }
  return { total, priced }
}
